import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IBankBillet from "Types/BankBillet";
import { State } from "store/reducers";

export const GET_MEI = "[MEI EDIT] GET_MEI";
export const GET_MEI_SUCCESS =
	"[MEI EDIT] GET_MEI_SUCCESS";
export const GET_MEI_FAILED =
	"[MEI EDIT] GET_MEI_FAILED";

export const EDIT_MEI = "[MEI EDIT] EDIT_MEI";
export const EDIT_MEI_SUCCESS =
	"[MEI EDIT] EDIT_MEI_SUCCESS";
export const EDIT_MEI_FAILED =
	"[MEI EDIT] EDIT_MEI_FAILED";

export const SET_VALUE = "[MEI EDIT] SET_VALUE";
export const CLEAR_VALUES = "[MEI EDIT] CLEAR_VALUES";

export function setValue(payload: any) {
	return (dispatch: any) => {
		dispatch({ type: SET_VALUE, payload });
	};
}
export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getBankBillet(id: string, callback?: Callback<IBankBillet>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MEI });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/BankBillet/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_MEI_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MEI_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_MEI_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function updateBankBillet(callback?: Callback<IBankBillet>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: EDIT_MEI });

		try {
			const state = getState();

			const { login, bankBilletEdit } = state;

			const { item } = bankBilletEdit;

			const model = {
				...item
			};

			const response = await api.sendPut("/BankBillet/" + item.id, model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: EDIT_MEI_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: EDIT_MEI_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: EDIT_MEI_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
